import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadDayBook,
  downloadDayBookReport,
  fetchFinanceJournalEntry,
} from "../../../services/finance/finance"
import moment from "moment"
import JournalEntryFilter from "./filter"
import { Link, useLocation, useNavigate } from "react-router-dom"
import closeIcon from "../../../assets/icons/close.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useDispatch, useSelector } from "react-redux"
import { setFilter } from "../../../store/actions"

const JournalEntry = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Day Book${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const dispatch = useDispatch()

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  console.log(`desimalrange`, desimalrange)

  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [dateFrom, setDatefrom] = useState("")
  const [dateTo, setDateto] = useState("")
  const [acc, setAcc] = useState("")

  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const toggle = () => setModal(!modal)

  const location = useLocation()
  const [voucherTypeId, setVoucherTypeId] = useState("")
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFinanceJournalEntry({
        params: `accounting_vouhers=1${
          search ? `&searchText=${search}` : "&searchText"
        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
          acc ? `&account_id=${acc}` : ""
        }${voucherTypeId ? `&voucher_type_id=${voucherTypeId}` : ""}${
          dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
        }${
          dateFrom
            ? `&start_date=${dateFrom}`
            : filters?.dateFrom
            ? `&start_date=${filters?.dateFrom}`
            : ""
        }${
          dateTo
            ? `&end_date=${dateTo}`
            : filters?.dateTo
            ? `&end_date=${filters?.dateTo}`
            : ""
        }`,
      })
      // setFetchedData(responce)
      // ${location?.state ? `&ledger_id=${location?.state?.ledger_id}` : ""}
      const newData = response?.data || []

      setFetchedData(prev =>
        page > 1 && prev
          ? {
              ...response, // update all fields from latest response
              data: [...(prev.data || []), ...(response.data || [])], // concat old + new data
              total_items: response.total_items, // update counts
              opening_balance: response.opening_balance,
              closing_balance: response.closing_balance,
              total_credit: response.total_credit,
              total_debit: response.total_debit,
              meta: response.meta,
              filter: response.filter,
            }
          : response
      )
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
    }
    fetchData()
    // setIsLoadingNextPage(responce != undefined ? false : true)
  }, [
    page,
    search,
    location,
    dateFrom,
    dateTo,
    voucherTypeId,
    dataPerPage,
    filters?.dateFrom,
    filters?.dateTo,
  ])
  const handleVoucherTypeChange = id => {
    setVoucherTypeId(id)
    setPage(1)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  // ${dateFrom ? `&start_date=${dateFrom}` : ""}${
  //   dateTo ? `&end_date=${dateTo}` : ""
  // }

  const handleView = item => {
    setViewData(item)
    toggle()
  }

  // const calculateVoucherTotal = (journalEntryDetails = []) => {
  //   if (!journalEntryDetails.length) return 0

  //   const voucherType = journalEntryDetails[0]?.voucher_type

  //   if (["Sales", "Receipt", "Contra"].includes(voucherType)) {
  //     return journalEntryDetails.reduce(
  //       (sum, entry) => sum + parseFloat(entry.credit_amount || 0),
  //       0
  //     )
  //   }

  //   if (["Purchase", "Payment", "Journal"].includes(voucherType)) {
  //     return journalEntryDetails.reduce(
  //       (sum, entry) => sum + parseFloat(entry.debit_amount || 0),
  //       0
  //     )
  //   }

  //   return 0
  // }

  const calculateVoucherTotal = (journalEntryDetails = []) => {
    if (!journalEntryDetails.length) return 0

    const voucherType = journalEntryDetails[0]?.voucher_type

    if (["Sales", "Receipt", "Contra"].includes(voucherType)) {
      const entryWithCredit = journalEntryDetails?.find(
        entry => parseFloat(entry?.credit_amount || 0) > 0
      )
      return parseFloat(entryWithCredit?.credit_amount || 0)
    }

    if (
      ["Purchase", "Cash Payment", "Bank Payment", "Journal"].includes(
        voucherType
      )
    ) {
      const entryWithDebit = journalEntryDetails?.find(
        entry => parseFloat(entry?.debit_amount || 0) > 0
      )
      return parseFloat(entryWithDebit?.debit_amount || 0)
    }

    return 0
  }

  const getRelevantLedgerName = (journalEntryDetails = []) => {
    if (!journalEntryDetails.length) return ""

    const voucherType = journalEntryDetails[0]?.voucher_type

    if (["Sales", "Receipt", "Contra"].includes(voucherType)) {
      const entryWithCredit = journalEntryDetails.find(
        entry => parseFloat(entry?.credit_amount || 0) > 0
      )
      return entryWithCredit?.ledger?.name || "-"
    }

    if (
      ["Purchase", "Bank Payment", "Cash Payment", "Journal"].includes(
        voucherType
      )
    ) {
      const entryWithDebit = journalEntryDetails.find(
        entry => parseFloat(entry?.debit_amount || 0) > 0
      )
      return entryWithDebit?.ledger?.name || "-"
    }

    return ""
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Date",
      renderCell: item => moment(item?.transaction_date).format("DD-MMM-YYYY"),
    },
    {
      label: "Voucher No.",
      renderCell: item => (
        <div className="text-link">
          <Link
            to={`/finance-voucher/view/${item?.voucher_entry?.id}`}
            onClick={() =>
              dispatch(
                setFilter({
                  dateFrom: dateFrom,
                  dateTo: dateTo,
                })
              )
            }
            className="text-capitalize pointer fw-bold"
          >
            {item?.reference_number}
          </Link>
          {/* <div
            onClick={() =>
              navigate(`/finance-voucher/view/${item?.voucher_entry?.id}`)
            }
            className="pointer fw-bold"
          >
            {item?.reference_number}
          </div> */}
        </div>
      ),
    },

    // {
    //   label: "Ledger",
    //   renderCell: item => (
    //     <div className="text-capitalize">
    //       {item?.ledger?.name ? item?.ledger?.name : "-"}
    //     </div>
    //   ),
    // },
    {
      label: "Voucher Type",
      renderCell: item => (
        <div className="text-capitalize">
          {item?.voucher_entry?.voucher_type?.voucher_type
            ? item?.voucher_entry?.voucher_type?.voucher_type
            : "-"}
        </div>
      ),
    },
    {
      label: "Particulars",
      renderCell: item => {
        const details = item?.journal_entry_details
        const ledgerName = getRelevantLedgerName(details)
        return <div className="text-capitalize">{ledgerName}</div>
      },
    },
    // {
    //   label: "Description",
    //   renderCell: item =>
    //     item?.description ? capitalize(item?.description) : "-",
    // },
    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => {
        const details = item?.journal_entry_details
        const voucherType = details?.[0]?.voucher_type
        const shouldShow = [
          "Purchase",
          "Bank Payment",
          "Journal",
          "Cash Payment",
        ].includes(voucherType)
        const amount = shouldShow ? calculateVoucherTotal(details) : 0
        return (
          <div className="text-end pe-5">
            {NumberFormat(amount, desimalrange, desimalrange)}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-3">Credit (AED)</div>,
      renderCell: item => {
        const details = item?.journal_entry_details
        const voucherType = details?.[0]?.voucher_type
        const shouldShow = ["Sales", "Receipt", "Contra"].includes(voucherType)
        const amount = shouldShow ? calculateVoucherTotal(details) : 0
        return (
          <div className="text-end pe-3">
            {NumberFormat(amount, desimalrange, desimalrange)}
          </div>
        )
      },
    },

    // {
    //   label: "Debit(AED)",
    //   renderCell: item => (item?.debit_amount ? item?.debit_amount : 0),
    // },
    // {
    //   label: "Credit(AED)",
    //   renderCell: item => (item?.credit_amount ? item?.credit_amount : 0),
    // },
  ]
  const viewColumn = [
    {
      label: "Voucher No.",
      renderCell: item => viewData?.reference_number,
    },
    {
      label: "Particulars",
      renderCell: item => (
        <div className="text-capitalize">
          {item?.ledger ? item?.ledger?.name : "-"}
        </div>
      ),
    },
    // {
    //   label: "Ledger",
    //   renderCell: item => (
    //     <div className="text-capitalize">
    //       {item?.ledger?.name ? item?.ledger?.name : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   label: "Voucher Type",
    //   renderCell: item => (
    //     <div className="text-capitalize">
    //       {item?.journal_entry_details[0]?.voucher_type
    //         ? item?.journal_entry_details[0]?.voucher_type
    //         : "-"}
    //     </div>
    //   ),
    // },
    {
      label: "Date",
      renderCell: item => moment(item?.created_at).format("DD-MMM-YYYY"),
    },
    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.debit_amount
            ? NumberFormat(
                Number(item?.debit_amount),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.credit_amount
            ? NumberFormat(
                Number(Number(item?.credit_amount)),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleAccChange = data => {
    setAcc(data)
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: crumb || "Reports", link: "#" },
                    { title: "Day Books", link: "/finance-day-book" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span
                  id={`PopoverLegacy-1`}
                  className="px-2 mb-3 btn btn-primary"
                >
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadDayBookReport({
                        params: `download=pdf&title=Day Book&accounting_vouhers=1${
                          search ? `&searchText=${search}` : "&searchText"
                        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
                          acc ? `&account_id=${acc}` : ""
                        }${
                          voucherTypeId
                            ? `&voucher_type_id=${voucherTypeId}`
                            : ""
                        }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : filters?.dateFrom
                            ? `&start_date=${filters?.dateFrom}`
                            : ""
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : filters?.dateTo
                            ? `&end_date=${filters?.dateTo}`
                            : ""
                        }`,
                        type: "pdf",
                        fileName: "daybook.pdf",
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadDayBookReport({
                        params: `download=excel&title=Day Book&accounting_vouhers=1${
                          search ? `&searchText=${search}` : "&searchText"
                        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
                          acc ? `&account_id=${acc}` : ""
                        }${
                          voucherTypeId
                            ? `&voucher_type_id=${voucherTypeId}`
                            : ""
                        }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : filters?.dateFrom
                            ? `&start_date=${filters?.dateFrom}`
                            : ""
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : filters?.dateTo
                            ? `&end_date=${filters?.dateTo}`
                            : ""
                        }`,
                        type: "excel",
                        fileName: "daybook.xlsx",
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {!fromDashboard ? (
              <>
                <JournalEntryFilter
                  handleSearchChange={handleSearchChange}
                  handleDateChange={handleDateChange}
                  // handleAccChange={handleAccChange}
                  resetData={{
                    dateFrom: filters?.dateFrom,
                    dateTo: filters?.dateTo,
                  }}
                  isImport={false}
                  handleVoucherTypeChange={handleVoucherTypeChange}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <div></div>
            )}

            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div
                  ref={tableContainerRef}
                  style={{ maxHeight: "490px", overflowY: "auto" }}
                >
                  {fetchedData?.data && (
                    <UpdateTable
                      className="mt-5"
                      nodes={fetchedData?.data}
                      paginate={fetchedData}
                      CurrentPage={page}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="15% 15% 20% 30% 10% 10%"
                      mobileWidth="40% 40% 40% 40% 40% 40%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-2">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {viewData?.journal_entry_details && (
                  <UpdateTable
                    className="mt-5"
                    nodes={viewData?.journal_entry_details}
                    columns={viewColumn}
                    handilpagedrop={false}
                    tableWidth="20% 20% 20% 20% 20%"
                    mobileWidth="40% 40% 40% 40% 40%"
                  />
                )}
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal>
    </React.Fragment>
  )
}

export default JournalEntry
